import { Provider } from "react-redux";
import "./App.css";
import HomePage from "./components/HomePage";
import { store } from './components/state/reducer/store'
function App() {
  
  return (
    <>
      <Provider store={store}>
        <HomePage />
      </Provider>
    </>
  );
}

export default App;
